import { styled } from '@mui/material';
import { HexAlphaColorPicker, HexColorPicker } from 'react-colorful';
import { HelixStyles } from '../../../helix';
/**
 * Styled HexAlphaColorPicker.
 */
export const StyledColorAlphaPicker = styled(HexAlphaColorPicker)(() => ({
    '.react-colorful': { height: 250 },
    '.react-colorful__saturation': {
        borderRadius: '0',
        boxShadow: 'none',
        '&-pointer': { borderWidth: 1 },
    },
    '.react-colorful__hue': {
        borderRadius: '1.5rem',
        height: 8,
        margin: '0.75rem 0 0.5rem 0',
    },
    '.react-colorful__hue-pointer': {
        borderRadius: '1.5rem',
        borderWidth: 1,
        height: 8,
        width: 8,
    },
    '.react-colorful__alpha': {
        borderRadius: '1.5rem',
        height: 8,
    },
    '.react-colorful__alpha-pointer': {
        borderRadius: '1.5rem',
        borderWidth: 1,
        height: 8,
        width: 8,
    },
}));
/**
 * Styled HexAlphaColorPicker.
 */
export const StyledColorPicker = styled(HexColorPicker)(() => ({
    '.react-colorful': { height: 250 },
    '.react-colorful__saturation': {
        borderRadius: '0',
        boxShadow: 'none',
        '&-pointer': { borderWidth: 1 },
    },
    '.react-colorful__hue': { margin: '0.75rem 0 1rem 0' },
    '.react-colorful__hue-pointer': {
        borderRadius: '1.5rem',
        borderWidth: 1,
        height: 8,
        width: 8,
    },
    '.react-colorful__last-control': {
        borderRadius: '1.5rem',
        height: 8,
    },
}));
/**
 * Clickable color swatch.
 */
export const ColorSwatch = styled('button')(() => ({
    border: 'none',
    borderRadius: '0.25rem',
    height: 24,
    width: 24,
    '&:focus': { outline: 'none' },
    '&:hover': {
        boxShadow: HelixStyles.elevationMD,
        cursor: 'pointer',
    },
    '&:focus-visible': { boxShadow: HelixStyles.focusVisible1 },
}));
